// extracted by mini-css-extract-plugin
export default {"root":"TooltipShort__root--26b3W","tooltipText":"TooltipShort__tooltipText--2hJ82","tooltipButton":"TooltipShort__tooltipButton--27ZwL"};